import { api } from 'services/api';

export const hospitalService = api.injectEndpoints({
  endpoints: (builder) => ({
    // prettier-ignore
    hospitals: builder.query<ResultModel<Hospitals>,HospitalsRequest>({
      query: (body) => ({
        url: `/Hospitals`,
        method: 'POST',
        body: { ...body },
      }),
    }),
    // prettier-ignore
    hospital: builder.query<ResultModel<Hospital>, { hospitalId: number }>({
      query: (body) => ({
        url: `/5C3D71A136CC7502/Detail`,
        method: 'POST',
        body: { ...body },
      }),
    }),
    // prettier-ignore
    hospitalDepartments: builder.query<ResultModel<HospitalDepartment[]>,HospitalDepartmentRequest>({
      query: (body) => ({
        url: `/5C3D71A136CC7502/Departments`,
        method: 'POST',
        body: { ...body },
      }),
    }),
    hospitalDepartment: builder.query<ResultModel<HospitalDepartment>, { departmentId: number }>({
      query: (body) => ({
        url: `/5C3D71A136CC7502/DepartmentWithResources`,
        method: 'POST',
        body: { ...body },
      }),
    }),
  }),
});

export const {
  useHospitalsQuery,
  useHospitalQuery,
  useHospitalDepartmentsQuery,
  useHospitalDepartmentQuery,
} = hospitalService;

